import * as React from "react"
import { Grid } from "@mui/material"
import { AccordionSeeker } from "@ui-seeker/core"

import SkuManagementBrandFilter from "./BrandFilter"


export default function SkuManagementFilters() {
    return <AccordionSeeker
        title="Filters"
        TransitionProps={{ unmountOnExit: false }}
        expanded={true}
    >
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
                <SkuManagementBrandFilter />
            </Grid>
        </Grid>
    </AccordionSeeker>
}
